import Service from 'react-reservice';

import { EOrderType } from '@aqx-core/common/api/order';

import { EUIBuySellType, EUIOrderTypeLabel } from './types';

export interface ITradeFormServiceContext {
  orderTypeLabel?: EUIOrderTypeLabel;
  loading?: boolean;
  buySellType?: EUIBuySellType;
  orderType?: EOrderType;
  preservedValues?: {
    lotSize?: string;
    units?: string;
  };
}

const defaultContext: ITradeFormServiceContext = {
  loading: false
};

class TradeFormService extends Service<ITradeFormServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  setBuySellType = (buySellType?: EUIBuySellType) => {
    this.context.buySellType = buySellType;
  };

  setOrderTypeLabel = (orderTypeLabel?: EUIOrderTypeLabel) => {
    this.context.orderTypeLabel = orderTypeLabel;
  };

  setOrderType = (orderType?: EOrderType) => {
    this.context.orderType = orderType;
  };

  setLoading = (loading?: boolean) => {
    this.context.loading = loading;
  };

  setPreservedValues = (values: { lotSize?: string; units?: string }) => {
    this.context.preservedValues = { ...values };
  };

  getPreservedValues = () => {
    return this.context.preservedValues || {};
  };

  clearPreservedValues = () => {
    this.context.preservedValues = undefined;
  };
}

export const tradeFormService = new TradeFormService();
